export interface SocialLink {
    id: number;
    link: string;
    icon: string;
    title: string;
}

export const SOCIAL_LINKS: Record<string, SocialLink> = {
    facebook: {
        id: 1,
        link: 'https://www.facebook.com/viewbidauctions/',
        icon: 'fa-brands fa-facebook-f',
        title: 'Facebook',
    },
    linkedin: {
        id: 3,
        link: 'https://www.linkedin.com/company/viewbid-auctions/?originalSubdomain=ca',
        icon: 'fa-brands fa-linkedin-in',
        title: 'LinkedIn',
    },
    instagram: {
        id: 4,
        link: 'https://www.instagram.com/viewbid.ca/',
        icon: 'fa-brands fa-instagram',
        title: 'Instagram',
    },
    youtube: {
        id: 4,
        link: 'https://www.youtube.com/@viewbidauctions4675',
        icon: 'fa-brands fa-youtube',
        title: 'Youtube',
    },
};
